<template>
  <v-container fluid class="main-view" ref="mainView" pa-0>
    <v-row :no-gutters="$vuetify.breakpoint.smAndUp" row wrap>
      <v-flex xs12>
        <v-fade-transition hide-on-leave>
          <property-information-form v-if="currentPage === 0" @price-calculated="handlePriceCalculated" />
          <price-results v-if="currentPage === 1" @go-back="currentPage = 0" :propertyInformation="propertyInformation" @go-to-details="currentPage = 2" @open-offer-request-form="handleOpenOfferRequestForm" />
          <price-and-compare-details v-if="currentPage === 2" @go-back="currentPage = 1"  :propertyInformation="propertyInformation" @open-offer-request-form="handleOpenOfferRequestForm" />
        </v-fade-transition>
      </v-flex>
    </v-row>

    <offer-request-form ref="offerRequestDialog" />
  </v-container>
</template>

<script>
  import PropertyInformationForm from "../components/PropertyInformationForm";
  import PriceResults from "../components/PriceResults";
  import PriceAndCompareDetails from "../components/PriceAndCompareDetails";
  import OfferRequestForm from "../components/OfferRequestForm";

  export default {
    name: 'MainView',
    components: {
      PropertyInformationForm,
      PriceResults,
      PriceAndCompareDetails,
      OfferRequestForm,
    },
    data: () => {
      return {
        currentPage: 0,
        propertyInformation: null,
      }
    },
    watch: {
      secretField(newValue) {
        if (newValue === 'testi-4444') {
          this.$emit('open-test-view')
        }
      },
      currentPage() {
        this.$nextTick(() => {
          this.$vuetify.goTo(this.$refs.mainView, { offset: 150 });
        })
      }
    },
    computed: {
      secretField() {
        return this.$store.state.propertyPowerDemand;
      },
    },
    methods: {
      handlePriceCalculated(e) {
        this.propertyInformation = e;
        this.currentPage = 1;
      },
      handleOpenOfferRequestForm(prices) {
        this.$refs.offerRequestDialog.open(prices);
      },
    },
  }
</script>


<style lang="scss">
  .pe-blue {
    background: #84D8EA;
  }
  .pe-yellow {
    background: #FFF8CC;
  }
  .pe-green {
    background: #50BE00;

    &.lighten {
      background: rgba(80, 190, 0, 0.6);
    }
  }
  .pe-purple {
    background: #6666AE;
  }
  .pe-grey {
    background: rgba(240, 230, 210, 0.6);

    &.lighten {
      background: rgba(240, 230, 210, 0.2);
    }
  }

  .main-btn {
    font-size: 26px;
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer;
    padding: 2px 10px;

    &.disabled {
      cursor: default;
    }

    &:focus, &:focus-visible, &:focus-within, &:active {
      border-width: 2px !important;
      border-style: solid !important;
      outline: none !important;
      border-color: #000000;
      padding-top: 0;
      padding-bottom: 0;
      background: rgba(0,0,0,0.1);
    }
  }

  @media only screen and (max-width: 600px) {
    .main-btn {
      font-size: 15px;
    }
  }
</style>
